import { TextInputBase } from '@synqo/frontend-component-library';
import { type FC } from 'react';
import { type ControlProps } from '../props';
import { useUpdateCustomization } from '../useUpdateCustomization';

export const NumberInputControl: FC<ControlProps> = ({ data: apiCustomization, locked, updateData }) => {
    const { state, setState } = useUpdateCustomization(apiCustomization, updateData);

    return (
        <TextInputBase
            label={apiCustomization.label}
            name={apiCustomization.name}
            value={state}
            onChange={setState}
            locked={locked}
            readOnly={locked}
            valid
        />
    );
};
